<template>
    <div class="container">
    <div v-if="header_mood" class="pt-5">
        <h2 class="text-center text-uppercase" v-html="header_mood.val('titolo')"></h2>
        <h3 class="text-center text-uppercase" v-html="header_mood.val('sottotitolo')"></h3>
        <p class="text-center mt-4" v-html="header_mood.val('descrizione_introduttiva')"></p>
    </div>
    <div v-else class="pt-5">
        <h2 class="text-center text-uppercase">Lasciati ispirare</h2>
        <h3 class="text-center text-uppercase">Scegli il tuo stile tra tutta la gamma prodotti</h3>
        <p class="text-center mt-4">Scopri i mood che abbiamo pensato per te e fatti guidare dalle nostre proposte</p>
    </div>

    <div class="all-moods d-flex flex-wrap">
        <div class="box-card p-2 mb-4" v-for="mood in moods" :key="mood.id">
            <div 
            @click="goToPage($router.resolve({ name: 'ispirazioni', params: { ispirazioni: mood.val('nome') } }).href)"
            >
                <img v-if="mood.val('image')" class="img-fluid" :src="mood.val('image').link({'x':500,'y':500,'ext':'webp'})" alt="">
                <img v-else class="img-fluid" src="/collezioni/placeholder.png" alt="" width="500" height="500">
                <p class="text-uppercase pt-3 mb-1 title-mood"> {{ mood.val('nome') }} </p>
                <p class="box-card-desc" v-html="mood.val('descrizione_web')"> </p>
        </div>
        </div>  
    </div>
    </div>   
</template>

<script>
import { defineComponent } from "@vue/runtime-core";
import { Schema } from "onpage-js";

export default defineComponent({
  props: {
    schema: {
      type: Schema,
      required: true,
    },
    pagine_web: {
      required: true,
    }
  },
  mounted() {
    window.document.getElementById('app').scrollIntoView()
  },
  data(){
    return {
        moods: null,
        pagina_web_mood: null,
        header_mood: null,
    };
  },
  async created(){
    this.refreshMood().then(()=>{
        //console.log(this.moods)
    })
  },
  methods: {
    goToPage(path) {
      console.log(path)
      this.$router.push({ path: `/${path.replace('#/', '')}` })
    },
    async refreshMood() {
      this.moods = await this.moods_query.all();
    },
    getPreviewMood(){
      this.pagina_web_mood = this.pagine_web.filter(x => x.val("nome") == "Ispirazioni");
      this.header_mood = this.pagina_web_mood[0].relSync("header")[0];
      console.log(this.header_mood)
    },
  },
  computed: {
    moods_query(){
      const schema = this.schema;
      if (!schema) return;
      const q = schema.query("mood");
      return q;
    },
  },
  watch:{
    pagine_web(){
        this.getPreviewMood();
    },
  }

})

</script>

<style>
.container h2, .container h3{
    font-size: 42px;
    color: #000;
    font-weight: 300;
}
.title-mood{
  font-size: 22px;
  font-weight: 600;
}
.container p{
    color: #646363;
}
.container h3{
    font-size: 32px;
    color: #646363;
}
.all-moods{
    padding: 50px 0;
}
.box-card{
    width: calc(100%/3);
    transition: all .3s;;
}
.box-card:hover{
  transform: scale(1.04);
}
.box-card p {
    text-align: center;
    font-weight: 300;
}
.box-card a{
    text-decoration: none;
}
.box-card-desc{
  font-size: 14px;
}

@media (max-width: 550px){
  .box-card{
    width: 100%;
    transition: all .3s;;
}
}
</style>